import { render, staticRenderFns } from "./FormItemComponent.vue?vue&type=template&id=4252551c&scoped=true&"
import script from "./FormItemComponent.vue?vue&type=script&lang=js&"
export * from "./FormItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252551c",
  null
  
)

export default component.exports